<div [ngStyle]="{ cursor: !artifactCount ? 'not-allowed' : 'pointer' }">
  <div
    class="artifact-button d-flex justify-content-between align-items-center"
    [ngClass]="{ 'pe-none ': !artifactCount }"
    (click)="onArtifactClick()"
  >
    <div>
      <span>{{ artifactName }}</span>
      <span> ({{ artifactCount }}) </span>
    </div>
    <img
      width="18"
      height="18"
      src="images/primary-arrow.svg"
      alt="Arrow"
    />
  </div>
</div>
